import React from 'react';
import PropTypes from 'prop-types';

// import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
import AccessibleIcon from '../common/AccessibleIcon';

import { Form } from 'react-bootstrap';


/*  Controlled/Uncontrolled usage:
        - Controlled: onChange + value
        - Uncontrolled: inputRef
*/

const propTypes = {
    className: PropTypes.string,
    inputId: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.array,
    showIconSmallRes: PropTypes.bool, // bootstrap xs resolution will replace label with fa icon specified by props.icon
    inputRef: PropTypes.object,
    children: PropTypes.node,
};

const defaultProps = {
    className: '',
    onChange: null,
    value: [],
    showIconSmallRes: false,
    children: null,
};

function FilterDropdown(props) {
    return (
        <div className={`filterDropdown ${props.className}`}>
            <label htmlFor={props.inputId}>
                {(props.showIconSmallRes) ?
                    <span>
                        <span className="d-none d-sm-inline">{props.label}</span>
                        <AccessibleIcon className={`d-inline-block d-sm-none ${props.icon}`} label={props.label} />
                    </span>
                    :
                    props.label
                }
            </label>
            <Form>
                {props.options.map((obj,i)=>{
                let selected = (props.value && (props.value.indexOf(obj.id)>=0));
                return (
                <Form.Check
                    key={obj.id}
                    type="checkbox"
                    label={obj.name}
                    checked={selected}
                    onChange={(e)=>{
                        props.onChange(e.target.checked,obj.id)
                    }}
                />
                )})}
            </Form>
        </div>
    );
}

FilterDropdown.propTypes = propTypes;
FilterDropdown.defaultProps = defaultProps;

export default FilterDropdown;